<template>
    <ModalComponent
        name="bloquearButacas"
        title="Bloquear / Liberar butacas"
        @close="$emit('close')"
        @closed="resetForm"
    >
        <b-row>
            <b-col cols="12 mb-3">
                <EtiquetaSelect v-model="etiqueta" />
            </b-col>
            <b-col cols="12">
                <FormInput label="Concepto" v-model="concepto" />
            </b-col>
            <b-col cols="12" class="mt-2">
                <h4>BUTACAS A BLOQUEAR / LIBERAR:</h4>
            </b-col>
            <b-col cols="12" class="mt-2">
                <b-card>
                    <b-card-body class="p-0">
                        <div v-for="(butaca, index) in butacas" :key="index">
                            <div class="d-flex align-items-center" >
                                <h5 class="mb-0 p-1">
                                    <template>
                                        {{ index + 1 }}.
                                        <span v-if="butaca.sector_name">
                                            Sector: {{ butaca.sector_name }} -
                                        </span>
                                    </template>
                        
                                    <span v-if="butaca.fila">
                                        Fila: {{ butaca.fila }} - Butaca: {{ butaca.butaca }}
                                    </span>
                        
                                    <template v-if="butaca.numeroPlaza">
                                        Plaza: {{ butaca.numeroPlaza }}
                                    </template>

                                    <template v-if="butaca.asiento?.fila && butaca.asiento?.asiento">
                                        <span v-if="butaca.asiento?.zona_nombre">
                                            Zona: {{ butaca.asiento.zona_nombre }}
                                        </span>
                                        <span>
                                            Fila: {{ butaca.asiento.fila }}
                                        </span>
                                        <span>
                                            Asiento: {{ butaca.asiento.asiento }}
                                        </span>
                                    </template>

                                    <template v-if="butaca.row && butaca.seat">
                                        <span v-if="butaca.zona_nombre">
                                            Zona: {{ butaca.zona_nombre }}
                                        </span>
                                        <span>
                                            Fila: {{ butaca.row }}
                                        </span>
                                        <span>
                                            Asiento: {{ butaca.seat }}
                                        </span>
                                    </template>
                                </h5>
                            </div>
                        </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col cols="12" class="text-right">
                <Button class="m-1" @click="bloquearButacas()">{{ bloqueoTitulo }}</Button>
            </b-col>
        </b-row>
    </ModalComponent>
</template>

<script setup>
    import { ref, computed } from 'vue';
    import ModalComponent from "@/components/backend/components/ModalComponent";
    import EtiquetaSelect from '@/modules/admin/etiquetas/components/EtiquetaSelect.vue';

    const props = defineProps({
        butacas: {
            type: Array,
            required: true
        }
    });

    const emit = defineEmits(['bloquearButacas', 'close']);

    const concepto = ref(null)
    const etiqueta = ref(null)

    const bloqueoTitulo = computed(() => {
        if (props.butacas.length === 0) {
            return 'Bloquear / Liberar'
        }

        const todasBloqueadas = props.butacas.every(butaca => butaca.bloqueada === true)
        const todasLibres = props.butacas.every(butaca => butaca.bloqueada !== true)

        if (todasBloqueadas) {
            return 'Liberar'
        }
        if (todasLibres) {
            return 'Bloquear'
        }
        return 'Bloquear / Liberar'
    })

    // Limpia el formulario al cerrar el modal (vía `closed`) y tras confirmar.
    // Sin esto, el estado de la operación anterior (etiqueta/concepto) se
    // reutilizaba al reabrir el modal y podía enviar una etiqueta accidental.
    function resetForm() {
        concepto.value = null
        etiqueta.value = null
    }

    function bloquearButacas() {
        emit('bloquearButacas', concepto.value, etiqueta.value)
        resetForm()
    }

    // Exponer la API pública para tests de <script setup> (VTU no accede a los
    // refs internos por defecto).
    defineExpose({ bloquearButacas, resetForm, concepto, etiqueta })
</script>